import React from 'react';
import { useHistory } from 'react-router-dom';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import Button from '../Button/Button';
import { H2 } from '../Heading/Heading';
import NamedLink from '../NamedLink/NamedLink';
import Page from '../Page/Page';
import TopbarSimplified from '../TopbarSimplified/TopbarSimplified';

import css from './ProfileCompletionGuard.module.css';

/** Prompt used instead of a critical action when private account details are incomplete. */
const ProfileCompletionGuard = ({ isProvider = false, missingProfileImage = false }) => {
  const intl = useIntl();
  const history = useHistory();
  const title = intl.formatMessage({ id: 'ProfileCompletionGuard.title' });

  return (
    <Page title={title} scrollingDisabled={false}>
      <TopbarSimplified />
      <main className={css.root}>
        <H2 as="h1">
          <FormattedMessage id="ProfileCompletionGuard.title" />
        </H2>
        {missingProfileImage ? (
          <p>
            <FormattedMessage id="ProfileCompletionGuard.profileImageMessage" />
          </p>
        ) : (
          <>
            <p>
              <FormattedMessage id="ProfileCompletionGuard.message" />
            </p>
            {isProvider ? (
              <p>
                <FormattedMessage id="ProfileCompletionGuard.providerMessage" />
              </p>
            ) : null}
          </>
        )}
        <div className={css.actions}>
          <NamedLink
            className={css.primaryAction}
            name={missingProfileImage ? 'ProfileSettingsPage' : 'ContactDetailsPage'}
          >
            <FormattedMessage
              id={
                missingProfileImage
                  ? 'ProfileCompletionGuard.addProfileImage'
                  : 'ProfileCompletionGuard.complete'
              }
            />
          </NamedLink>
          <Button type="button" onClick={() => history.goBack()}>
            <FormattedMessage id="ProfileCompletionGuard.back" />
          </Button>
        </div>
      </main>
    </Page>
  );
};

export default ProfileCompletionGuard;
